const config = {
  administrator: 'Administrator',
  stage: 'Change other interview stage',
  language: 'Changing the system language',
  set: 'Set',
  log_out: 'Logout',
  logout_tip: 'Are you sure you want to log out?',
  msg_all_loaded: 'All loaded',
  msg_del_success: 'Notification deleted!',
  msg_del_fail: 'Notification delete failed!',
  notice: 'notice',
  ChangeRole: 'All roles',
  change_pwd: 'Change Password',
  required_old_pwd: 'Please enter the old password',
  required_new_pwd: 'Please enter a new password',
  required_confirm_pwd: 'Please re-enter your password',
  change_successfully: 'Successfully',
  change_failed: 'Failed in change',
  old_password: 'Old password',
  new_password: 'Create New Password',
  confirm_password: 'Confirm New Password',
  save_change: 'OK',
  _ChangeRole: 'Change role'
};

export default config;
